var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6838 32.3641V33.2872H25.2067V32.3641L25.1832 32.3414L22.9897 30.2251V28.0861H13.9008V30.2251L11.7072 32.3414L11.6838 32.3641Z",
    fill: "#BCBEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7642 28.0861H23.1262V30.1665H13.7642V28.0861Z",
    fill: "#A7A9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6838 32.2718V33.2872H25.2067V32.2718L25.1832 32.2469H11.7072L11.6838 32.2718Z",
    fill: "#A7A9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56314 23.9251H37.6894V3.12067L8.56314 23.9251Z",
    fill: "#C1E5F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.241348 1.91622V27.21C0.241348 28.264 1.07764 29.1263 2.09983 29.1263H35.8309C36.8531 29.1263 37.6894 28.264 37.6894 27.21V1.91622C37.6894 0.862275 36.8531 0 35.8309 0H2.09994C1.07775 0 0.241348 0.862275 0.241348 1.91622Z",
    fill: "#E8E4DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.241348 1.89508V23.9251H37.6894V1.89508C37.6894 0.852763 36.8531 0 35.8309 0H2.09983C1.07764 0 0.241348 0.852763 0.241348 1.89508Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28157 2.08044H35.6089V22.8849H1.28157V2.08044Z",
    fill: "#C3E6F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3979 3.5462H33.6743V15.4856H15.3979V3.5462Z",
    fill: "#EEEEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3979 3.5462H33.6743V5.19302H15.3979V3.5462Z",
    fill: "#E96666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4683 7.04187H31.5366V12.9509H17.4683V7.04187Z",
    fill: "#D2D6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25966 7.41199H24.536V19.3514H6.25966V7.41199Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25966 7.41199H24.536V9.0588H6.25966V7.41199Z",
    fill: "#0099C9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0556 10.9409H20.3171V11.8231H10.0556V10.9409Z",
    fill: "#D2D6D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0556 13.3361H20.3171V14.2183H10.0556V13.3361Z",
    fill: "#D2D6D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0556 15.5284H20.3171V16.4107H10.0556V15.5284Z",
    fill: "#D2D6D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3575 11.8231C21.1385 11.8231 20.9609 11.6256 20.9609 11.382C20.9609 11.1383 21.1385 10.9409 21.3575 10.9409C21.5766 10.9409 21.7542 11.1383 21.7542 11.382C21.7542 11.6256 21.5766 11.8231 21.3575 11.8231Z",
    fill: "#FF9966"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3575 14.2183C21.1385 14.2183 20.9609 14.0208 20.9609 13.7772C20.9609 13.5336 21.1385 13.3361 21.3575 13.3361C21.5766 13.3361 21.7542 13.5336 21.7542 13.7772C21.7542 14.0208 21.5766 14.2183 21.3575 14.2183Z",
    fill: "#E52B50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3575 16.4107C21.1385 16.4107 20.9609 16.2132 20.9609 15.9696C20.9609 15.7259 21.1385 15.5284 21.3575 15.5284C21.5766 15.5284 21.7542 15.7259 21.7542 15.9696C21.7542 16.2132 21.5766 16.4107 21.3575 16.4107Z",
    fill: "#4EC9DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.955893a81c453627d306d93fa74d1e65.svg";
export { ForwardRef as ReactComponent };